<template>
  <el-upload
    action=""
    :auto-upload="true"
    :http-request="upload"
    :show-file-list="false"
    :drag="drag"
    v-bind="$attrs"
  >
    <slot>
      <base-button v-if="!drag" type="primary">
        点击上传
      </base-button>
      <template v-else>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
      </template>
    </slot>
    <template slot="tip">
      <slot name="tip"></slot>
    </template>
  </el-upload>
</template>

<script>
import { uploadAttachment } from "@/api/userCenter/file"
import {
  getFileHash,
  resolveFileName,
  handleOTAFile,
  getFileSizeStr,
  randomString
} from "@/utils/common"
import { BaseButton } from "@/components/UIComponents"
import { uploadFile, getUrlByPath } from "@/utils/uploadFile"

export default {
  name: "base-upload",
  components: {
    BaseButton
  },
  props: {
    drag: Boolean,
    enableCheckOTA: {
      type: Boolean,
      default: true
    },
    urlPrefix: {
      type: String,
      default: "https://new-service.oss-cn-hangzhou.aliyuncs.com/"
    },
    uploadCatalogue: {
      type: String,
      default: "sheet-attachment/"
    },
    uploadTo: {
      type: String,
      default: "Server" // ["OSS", "Server"]
    },
    limitedFileSuffix: Array
  },
  methods: {
    // 上传
    async upload(params) {
      console.log("upload",params)
      let file
      try {
        file = params.file
        let { ext } = resolveFileName(file.name)
        if (this.limitedFileSuffix && !this.limitedFileSuffix.includes(ext)) {
          throw `文件类型不合法,仅支持 ${this.limitedFileSuffix.join(",")}`
        }

        file.ext = ext
        file.sizeStr = getFileSizeStr(file.size)
        file.tempId = randomString(10)
        this.startUpload(file)

        let res = null
        // 获取文件hash，若是OTA文件(.bin)，则校验后移除文件末尾 hash 信息
        if (ext == "bin" && this.enableCheckOTA) {
          res = await handleOTAFile(file)
          if (!res.result) throw "文件校验失败！"
          else file = res.file // 移除 hash 信息后的文件
        }

        // 上传至oss
        file = await uploadFile(file, this.uploadCatalogue)

        // 上传至OSS：直接返回文件
        if (this.uploadTo == "OSS") {
          this.uploadFinished(file)
        }
        // 上传至服务器：先传回服务器再返回文件信息
        else {
          let res = await this.uploadToServer(file)
          if (res.data.code != 0) throw "回传服务器失败！"
          else {
            file.id = res.data.data.id
            this.uploadFinished(file)
          }
        }
      } catch (error) {
        this.uploadFailed(file, error)
      }
    },
    // 上传至服务器
    uploadToServer(file) {
      return uploadAttachment({
        id: file.id,
        name: file.name,
        type: file.ext,
        path: file.uploadPath,
        sizeStr: file.sizeStr,
        sizeByte: file.size,
        hash: file.hash
      })
    },
    // 获取文件信息
    getFileInfo(file) {
      return {
        id: file.id,
        tempId: file.tempId,
        name: file.name,
        path: file.uploadPath,
        url: file.url ? file.url : getUrlByPath(file.uploadPath),
        sizeStr: file.sizeStr,
        sizeByte: file.size,
        type: file.ext,
        hash: file.hash
      }
    },
    // 开始上传
    startUpload(file) {
      this.$emit("startUpload", this.getFileInfo(file))
    },
    // 上传成功
    uploadFinished(file) {
      this.$emit("uploadFinished", this.getFileInfo(file))
    },
    // 上传错误
    uploadFailed(file, message) {
      if (["文件校验失败！", "回传服务器失败！"].includes(message))
        message = `${message} [${file.name}]`
      else if (message.startsWith("文件类型不合法")) {
        message = `${message} [${file.name}]`
      } else message = `网络错误，文件上传失败！ [${file.name}]`

      this.$message.error(message)
      this.$emit("uploadFailed", this.getFileInfo(file))
      // let uploadFiles = this.$refs.upload.$data.uploadFiles
      // let index = uploadFiles.findIndex(i => i.name == file.name)
      // uploadFiles.splice(index, 1)
    }
  }
}
</script>
